/** Cookie name for storing the pending referrer user ID. */
export const REFERRAL_COOKIE: string = 'REFERRAL_CODE';

/** Cookie max-age in seconds (7 days). */
export const REFERRAL_COOKIE_MAX_AGE: number = 7 * 24 * 60 * 60;

/** UUID v4 regex for userId validation. */
export const UUID_RE: RegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * X handle (the shareable referral code, `/r/<handle>`): 1–15 of `[A-Za-z0-9_]`,
 * optional leading `@`. UUIDs contain `-`, so the two patterns never overlap.
 */
export const X_HANDLE_RE: RegExp = /^@?[A-Za-z0-9_]{1,15}$/;

/** Strip a leading `@` so the stored code matches the bare `x_handle` column. */
export function normalizeReferralCode(code: string): string {
  return code.replace(/^@/, '');
}
